import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import './index.css'
import { AUTH_INVALID_EVENT } from './api/client'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      // /auth/me doit re-checker quand l'utilisateur revient sur l'onglet,
      // sinon une session purgée côté serveur n'est jamais détectée.
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
})

// Quand le client détecte un 401 sur un endpoint authentifié, on purge le cache
// React Query et on marque la session comme invalide — App.tsx va re-rendre et
// basculer sur l'écran Login (la revalidation à chaque navigation gère le reste).
// IMPORTANT : pas de location.reload() ici → sinon boucle infinie car le 1er
// /auth/me sans cookie après reload re-déclenche l'event qui re-déclenche reload.
window.addEventListener(AUTH_INVALID_EVENT, () => {
  // marque la query me comme « pas authentifié » pour faire basculer App.tsx
  queryClient.setQueryData(['me'], { authenticated: false })
  // vide les autres caches (recap, nuits, etc.) pour qu'aucune donnée privée
  // ne reste affichée après bascule sur Login
  queryClient.removeQueries({
    predicate: (q) => !(Array.isArray(q.queryKey) && q.queryKey[0] === 'me'),
  })
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
